import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "@components/CustomText";
import DropdownList from "./components/dropdownList";

export default function DropdownInputView(props) {
  const { data, mainContainer = {}, headingStyle = {} } = props;
  return (
    <View style={[styles.view, mainContainer]}>
      <CustomText variant="heading_24" style={[styles.heading, headingStyle]}>
        {data.heading}
      </CustomText>
      <DropdownList {...props} />
    </View>
  );
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    backgroundColor: "white",
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  heading: {
    fontSize: 22,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 34,
    color: "rgba(0, 0, 0, 0.86)",
    marginBottom: 36,
  },
});
